import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-130" data-mp="17ws2s9xeyodg">
      <div className="mx-auto max-w-md" data-id="element-131" data-mp="1mmz9jse26iyb">
        <h2 className="text-center font-display text-[1.9rem] font-extrabold uppercase leading-tight text-ink sm:text-[2.6rem]" data-id="element-132" data-mp="1hopgbnbw9sfc">
          <span aria-hidden="true" data-id="element-133" data-mp="tzwhnj3w16h1">🏆 </span>Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-134" data-mp="p0a418k5do7p">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-135" data-mp="13xaw5d693l6p">
            Football Ready Pack
          </span>

          <dl data-id="element-136" data-mp="2fav4osnzc2sz">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-137" data-mp="2add5vv3of3yp">
                <dt className="text-ink/80" data-id="element-138" data-mp="pmbhvy3xda73">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-139" data-mp="ui8z06n0ikkx">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-140" data-mp="zjg8ca4szrtp">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-141" data-mp="13iyrb0d2dstw">
                Total Value:
              </dt>
              <dd className="font-bold text-ink/40 line-through" data-id="element-142" data-mp="6vkcf7n263xz">$212 USD</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-143" data-mp="bqpvzzszn6iw">
            Today only
          </p>
          <div className="border-b border-ink/10 pb-6 pt-2" data-id="element-144" data-mp="klnpb801slar">
            <p className="flex items-end justify-center gap-2" data-id="element-145" data-mp="kmyw7gosi963">
              <span className="pb-2 text-4xl leading-none" aria-hidden="true" data-id="element-146" data-mp="3k7uh2gol9ts4">
                🏆
              </span>
              <span className="font-display text-7xl font-extrabold leading-none text-brand" data-id="element-147" data-mp="3o8efroot95gd">
                $27
              </span>
              <span className="pb-2 text-sm font-bold text-brand" data-id="element-148" data-mp="qgxgu1wch7oc">USD</span>
            </p>
            <p className="mt-3 flex items-center justify-center gap-1.5 text-[11px] font-medium text-ink/55" data-id="element-149" data-mp="155k6awforfta">
              <GlobeIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-150" data-mp="106ph9cr4kv0q" />
              You&apos;ll be charged in your local currency at checkout.
            </p>
          </div>

          <CtaButton className="mt-7 w-full" data-id="element-151" data-mp="7hrxf579mq5v" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-152" data-mp="7j3cw2a2pmct">
            Instant Download · One-Time Payment · Lifetime Access · 30-Day
            Guarantee
          </p>
        </div>
      </div>
    </section>;
}